import { ADD_MOBILE_CONFIGURATION,
    ADD_MOBILE_CONFIGURATION_SUCCESS,
    ADD_MOBILE_CONFIGURATION_FAILURE,
    GET_MOBILE_CONFIGURATION,
    GET_MOBILE_CONFIGURATION_SUCCESS,
    GET_MOBILE_CONFIGURATION_FAILURE
} from "../Constants";

const init = {
    email: {},
    data: {},
    get_data: {}
};

const MobileConfigurationReducer = (state = init, action) => {
    switch (action.type) {
        case ADD_MOBILE_CONFIGURATION:
            return { ...state, loading: true };
        case ADD_MOBILE_CONFIGURATION_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case ADD_MOBILE_CONFIGURATION_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case GET_MOBILE_CONFIGURATION:
            return { ...state, loading: true };
        case GET_MOBILE_CONFIGURATION_SUCCESS:
            return { ...state, loading: false, get_data: action.payload };
        case GET_MOBILE_CONFIGURATION_FAILURE:
            return { ...state, loading: false, get_data: action.payload };
        default:
            return state;
    }
};

export default MobileConfigurationReducer;